import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';

import { CompanyHeader } from '@hmax-order/shared/types';
import { CompanyHeaderService } from '../company-header/company-header.service';

@Component({
  selector: 'hmax-company-report-header',
  standalone: true,
  templateUrl: './company-report-header.component.html',
  styleUrls: ['./company-report-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule],
})
export class CompanyReportHeaderComponent {
  private _companyHeaderService = inject(CompanyHeaderService);

  readonly companyHeader = this._companyHeaderService.companyHeader;
  @Input() company!: CompanyHeader;
}
